var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tenancy-all-projects-wrapper" },
    [
      _c("sticky", [
        _c("div", { staticClass: "clearfix header-panel" }, [
          _c("div", { staticClass: "header" }, [
            _c("span", { staticClass: "notice-header" }, [
              _vm._v(
                "\n          " +
                  _vm._s(
                    _vm.$i18n.t("tenantProjects.allTenantProjects.title")
                  ) +
                  "\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "right-btns" },
            [
              _c(
                "HKLButton",
                { attrs: { color: "orange" }, on: { click: _vm.exportExcel } },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("action.exportSearchResults")) +
                      "\n        "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn--darkblue",
                  attrs: { type: "button", role: "reset-button" },
                  on: {
                    click: function ($event) {
                      return _vm.resetFilters()
                    },
                  },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("action.resetFilter")) +
                      "\n        "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn--orange",
                  attrs: {
                    id: "query-btn",
                    type: "button",
                    role: "search-button",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.queryTenancyAllProjects()
                    },
                  },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("action.search")) +
                      "\n        "
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "all-tenant-projects-table" },
        [
          _c("div", { staticStyle: { "margin-left": "15px" } }, [
            _c("span", [
              _vm._v(_vm._s(_vm.$t("total") + ": " + _vm.displayListLength)),
            ]),
          ]),
          _vm._v(" "),
          _c("CommonTable", {
            ref: "all-tenant-projects",
            attrs: {
              renderHeaderList: _vm.itemHeaders,
              tableId: "all-tenant-projects",
              needSearch: true,
              yScrollAuto: true,
              tableContentLists: _vm.sortedItems,
              getDisplayListLength: _vm.getDisplayListLength,
              defaultOrder: true,
              defaultOrderKey: "date",
              interactionFunc: _vm.interactionFunc,
              getConditions: _vm.getConditions,
              enterEvent: _vm.queryTenancyAllProjects,
              orderByDateKeys: ["date"],
              orderMethods: _vm.orderMethods,
              getTableOrder: _vm.getTableOrder,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "HKLRemindModal",
        { ref: "remindEmptyModal" },
        [
          _c("template", { slot: "title" }, [
            _vm._v("\n      " + _vm._s(_vm.$t("hint.emptySearch")) + "\n    "),
          ]),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }